var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 48 48",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.07,19.51,28,23.2,30,29.13a.57.57,0,0,1-.87.63L24,26.15l-5.08,3.7a.56.56,0,0,1-.79-.15.62.62,0,0,1-.08-.48L20,23.3l-5.07-3.7a.55.55,0,0,1,.32-1h6.27l1.95-5.93a.55.55,0,0,1,1.06-.09l1.95,5.92h6.27a.56.56,0,0,1,.55.57A.53.53,0,0,1,33.07,19.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,4.5s-11.26,2-15.25,2v20a11.16,11.16,0,0,0,.8,4.1,15,15,0,0,0,2,3.61,22,22,0,0,0,2.81,3.07,34.47,34.47,0,0,0,3,2.48,34,34,0,0,0,2.89,1.86c1,.59,1.71,1,2.13,1.19l1,.49a1.44,1.44,0,0,0,1.24,0l1-.49c.42-.2,1.13-.6,2.13-1.19a34,34,0,0,0,2.89-1.86,34.47,34.47,0,0,0,3-2.48,22,22,0,0,0,2.81-3.07,15,15,0,0,0,2-3.61,11.16,11.16,0,0,0,.8-4.1v-20C35.26,6.53,24,4.5,24,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.2d3ada42c1ecd94f49d93bdabe537be1.svg";
export { ForwardRef as ReactComponent };